import { apiServices } from '../services/api.services';
import { toast } from 'react-toastify';
import i18n from '../../i18n';
import store from '../store';

function _waitInit(resolve, reject) {
  var {logged} = store.getState().rLink;
  if (logged)
    return resolve();
  setTimeout(() => {
    _waitInit(resolve, reject);
  }, 500);
}

async function waitInit() {
  return new Promise((resolve, reject) => {
    _waitInit(resolve, reject);
  });
}

export const reloadMap = () => {
  return async (Dispatch) => {
    await waitInit();
    var {vip} = store.getState().infos;
    if (vip.plan > 2) {
      await apiServices.get("/map", { init: true }).then((res) => {
        if (!res || !res.data) {
          Dispatch({type: 'SET_DEFAULT_MAP', error: 'noData'});
          return toast.error(i18n.t(`errors.noData`, { ns: "map" }));
        }
        if (!res.data.success) {
          Dispatch({type: 'SET_DEFAULT_MAP', error: res.data.msg || res.data.code});
          return toast.error(i18n.t(`errors.${res.data.msg}`, { ns: "map" }));
        }
        Dispatch({ type: 'UPDATE_MAP', data: res.data.data });
      }).catch(err => {
        Dispatch({type: 'SET_DEFAULT_MAP', error: 'noResponse'});
        return err;
      });
    } else {
      Dispatch({type: 'SET_DEFAULT_MAP', error: '9005'});
    }
  };
};

export const getHeatmap = (steamId, start, end) => {
  return async (Dispatch) => {
    await waitInit();
    await apiServices.get(`/heatmap`, { player: steamId, start, end}).then((res) => {
      if (!res || !res.data) 
        return toast.error(i18n.t(`errors.noData`, { ns: "map" }));
      if (!res.data.success)
        return toast.error(i18n.t(`errors.${res.data.msg}`, { ns: "map" }));
      Dispatch({ type: 'UPDATE_HEATMAP', data: res.data.data });
    }).catch(err => {
      return err;
    });
  };
};